"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("underscore");
const core_1 = require("@angular/core");
const core_2 = require("@uirouter/core");
const organisation_service_1 = require("../services/organisation.service");
const devextreme_angular_1 = require("devextreme-angular");
require("../Models");
const dnaRSnackBar_service_1 = require("../../common/dna-r/dnaRSnackBar.service");
const i0 = require("@angular/core");
const i1 = require("@uirouter/core");
const i2 = require("../services/organisation.service");
const i3 = require("../../common/dna-r/dnaRSnackBar.service");
const i4 = require("devextreme-angular");
const i5 = require("devextreme-angular/ui/nested");
const i6 = require("devextreme-angular/core");
const i7 = require("@angular/forms");
const i8 = require("@angular/common");
function DeviceActivationComponent_div_16_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const facility_r8 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(facility_r8);
} }
function DeviceActivationComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "ul");
    i0.ɵɵtemplate(2, DeviceActivationComponent_div_16_li_2_Template, 2, 1, "li", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r6 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", data_r6.value);
} }
function DeviceActivationComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h3", 35);
    i0.ɵɵtext(2, "PRODA device activation");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function DeviceActivationComponent_option_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 36);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("value", item_r10);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r10);
} }
function DeviceActivationComponent_ul_51_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵelementStart(1, "li");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const serverValidationMessage_r11 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(serverValidationMessage_r11);
} }
const _c0 = function () { return ["deviceName", "prodaOrganisationId", "facilities", "deviceActivationDate", "deviceExpiryDate", "keyExpiryDate", "status"]; };
if (!/localhost/.test(document.location.host)) {
    core_1.enableProdMode();
}
class DeviceActivationComponent {
    constructor($state, organisationService, snackBarService, notificationService) {
        this.$state = $state;
        this.organisationService = organisationService;
        this.snackBarService = snackBarService;
        this.notificationService = notificationService;
        this.activatedDevices = [];
        this.devicesDropdownList = [];
        this.prodaOrganisationId = "";
        this.deviceName = "";
        this.deviceActivationCode = "";
        this.prodaOrganisationIdValidator = new RegExp(/^[0-9]{9,11}$/);
        this.deviceNameValidator = new RegExp(/^[A-Za-z0-9_\.\-]+$/);
        this.deviceActivationCodeValidator = new RegExp(/^[A-Za-z0-9]{9,11}$/);
        this.prodaOrganisationIdIsReadOnly = true;
        this.prodaOrganisationIdValidationMessage = "";
        this.deviceNameValidationMessage = "";
        this.deviceActivationCodeValidationMessage = "";
        this.serverErrorMessage = "";
        this.serverValidationMessages = [];
        this.activateNewDevice = () => {
            this.popupVisible = true;
        };
        this.cancel = () => {
            this.popupVisible = false;
            this.resetDeviceActivationProperties();
            this.resetValidationMessages();
        };
        this.validateProdaOrganisationId = () => {
            let valid = this.prodaOrganisationIdValidator.test(this.prodaOrganisationId);
            this.prodaOrganisationIdValidationMessage = valid ? "" : "Please enter a valid PRODA organisation ID (RA number)";
            return valid;
        };
        this.validateDeviceName = () => {
            let valid = this.deviceNameValidator.test(this.deviceName);
            this.deviceNameValidationMessage = valid ? "" : "Please enter a valid PRODA device name";
            return valid;
        };
        this.validateDeviceActivationCode = () => {
            let valid = this.deviceActivationCodeValidator.test(this.deviceActivationCode);
            this.deviceActivationCodeValidationMessage = valid ? "" : "Please enter a valid device activation code";
            return valid;
        };
        this.saveNewDevice = () => {
            // Perform validation on all three fields. Only proceed if each field is valid.
            let valid = [this.validateProdaOrganisationId(), this.validateDeviceName(), this.validateDeviceActivationCode()];
            if (!valid.every(Boolean))
                return;
            // Send the device activation fields to the server.
            // Handle success and failure results.
            this.organisationService.activateProdaDevice(this.prodaOrganisationId, this.deviceName, this.deviceActivationCode)
                .then(() => {
                this.refreshActivatedProdaDevices();
                this.cancel();
            }, (error) => {
                if (!error.modelStateSummary) {
                    this.notificationService.error("Unexpected error while activating the PRODA device.");
                }
                else {
                    this.prodaOrganisationIdValidationMessage = (error.modelStateSummary.prodaOrganisationId) ? error.modelStateSummary.prodaOrganisationId : "";
                    this.deviceNameValidationMessage = (error.modelStateSummary.deviceName) ? error.modelStateSummary.deviceName : "";
                    this.deviceActivationCodeValidationMessage = (error.modelStateSummary.deviceActivationCode) ? error.modelStateSummary.deviceActivationCode : "";
                    this.serverErrorMessage = error.modelStateSummary.unspecified;
                    this.serverValidationMessages = (error.data.modelState.deviceActivationError) ? error.data.modelState.deviceActivationError : [];
                }
            });
        };
        this.refreshActivatedProdaDevices = () => {
            this.organisationService.getActivatedProdaDevices()
                .then((result) => {
                this.prodaOrganisationId = result.prodaOrganisationId;
                this.prodaOrganisationIdIsReadOnly = (this.prodaOrganisationIdValidator.test(result.prodaOrganisationId));
                this.activatedDevices = result.devices;
                this.devicesDropdownList = result.facilityRaNumbers;
            }, (error) => {
                this.snackBarService.failure("Unable to display devices. Either your computer is offline, or Resident Manager is having problems of its own.");
            });
        };
        this.resetDeviceActivationProperties = () => {
            if (!this.prodaOrganisationIdIsReadOnly) {
                this.prodaOrganisationId = "";
            }
            this.deviceName = "";
            this.deviceActivationCode = "";
        };
        this.resetValidationMessages = () => {
            this.prodaOrganisationIdValidationMessage = "";
            this.deviceNameValidationMessage = "";
            this.deviceActivationCodeValidationMessage = "";
            this.serverErrorMessage = "";
            this.serverValidationMessages = [];
        };
    }
    ngOnInit() {
        this.refreshActivatedProdaDevices();
        this.popupVisible = false;
    }
    onCellPrepared(e) {
        if (e.column.dataField == "status") {
            if (e.displayValue == "Expired" || e.displayValue == "Disabled") {
                e.cellElement.classList.add("status-highlight");
            }
            if (e.data.statusReason) {
                e.cellElement.innerHTML = e.displayValue + " - " + e.data.statusReason;
            }
        }
    }
}
exports.DeviceActivationComponent = DeviceActivationComponent;
DeviceActivationComponent.ɵfac = function DeviceActivationComponent_Factory(t) { return new (t || DeviceActivationComponent)(i0.ɵɵdirectiveInject(i1.StateService), i0.ɵɵdirectiveInject(i2.OrganisationService), i0.ɵɵdirectiveInject(i3.DnaRSnackBarService), i0.ɵɵdirectiveInject('notification.service')); };
DeviceActivationComponent.ɵcmp = i0.ɵɵdefineComponent({ type: DeviceActivationComponent, selectors: [["device-activation"]], viewQuery: function DeviceActivationComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(devextreme_angular_1.DxDataGridComponent, true);
        i0.ɵɵviewQuery(devextreme_angular_1.DxPopupComponent, true);
    } if (rf & 2) {
        var _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dataGrid = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popup = _t.first);
    } }, decls: 57, vars: 42, consts: [["nav-publisher", "admin", 1, "device-activation"], [1, "page-header"], [1, "col-xs-9"], [1, "col-xs-3", "create-new-btn"], ["type", "button", 1, "btn", "btn-primary", "btn-lg", "pull-right", 3, "click"], [1, "col-xs-12", "device-activation-table"], ["id", "dataGrid", 3, "dataSource", "columns", "showBorders", "showColumnLines", "showRowLines", "cellHintEnabled", "allowColumnResizing", "columnAutoWidth", "noDataText", "onCellPrepared"], [3, "enabled"], ["cssClass", "content-wrap", "dataField", "deviceName", "alignment", "left", "dataType", "string", "caption", "DEVICE NAME", 3, "width", "allowSorting"], ["cssClass", "content-wrap", "dataField", "prodaOrganisationId", "alignment", "left", "dataType", "string", "caption", "ORGANISATION ID (RA)", 3, "width", "allowSorting"], ["cssClass", "content-wrap", "dataField", "facilities", "alignment", "left", "dataType", "string", "caption", "FACILITY/S", "cellTemplate", "facilitiesTemplate", 3, "width", "allowSorting"], [4, "dxTemplate", "dxTemplateOf"], ["cssClass", "content-wrap", "dataField", "deviceActivationDate", "alignment", "left", "format", "dd MMM yyyy", "dataType", "date", "caption", "ACTIVATED", 3, "width", "allowSorting"], ["cssClass", "content-wrap", "dataField", "deviceExpiryDate", "alignment", "left", "format", "dd MMM yyyy", "dataType", "date", "caption", "DEVICE EXPIRY DATE", 3, "width", "allowSorting"], ["cssClass", "content-wrap", "dataField", "keyExpiryDate", "alignment", "left", "format", "dd MMM yyyy", "dataType", "date", "caption", "KEY EXPIRY DATE", 3, "width", "allowSorting"], ["cssClass", "content-wrap", "dataField", "status", "alignment", "left", "dataType", "string", "caption", "STATUS", 3, "width", "allowSorting"], ["id", "popup", "width", "600", "height", "auto", "showTitle", "true", "dragEnabled", "false", "closeOnOutsideClick", "true", "showCloseButton", "true", "container", ".ng-scope", "titleTemplate", "title", 3, "visible", "visibleChange", "onHiding"], [1, "modal-body"], [1, "form-group"], ["for", "prodaOrganisationId", 1, "control-label"], ["name", "prodaOrganisationId", 1, "form-control", "input-lg", 3, "disabled", "ngModel", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["data-automation", "prodaOrganisationIdValidationMessage", 1, "validation-message", 3, "hidden"], ["for", "deviceName", 1, "control-label"], ["required", "", "type", "text", "name", "deviceName", "maxlength", "50", 1, "form-control", "input-lg", 3, "ngModel", "ngModelChange"], ["nameVar", "ngModel"], ["data-automation", "deviceNameValidationMessage", 1, "validation-message", 3, "hidden"], ["for", "deviceActivationCode", 1, "control-label"], ["required", "", "type", "text", "name", "deviceActivationCode", "maxlength", "10", 1, "form-control", "input-lg", 3, "ngModel", "ngModelChange"], ["data-automation", "deviceActivationCodeValidationMessage", 1, "validation-message", 3, "hidden"], [1, "server-validation-message", 3, "hidden"], [4, "ngFor", "ngForOf"], [1, "modal-footer"], ["type", "button", 1, "btn", "btn-warning", "btn-lg", "pull-left", 3, "click"], ["type", "button", "data-automation", "deviceActivationSave", 1, "btn", "btn-primary", "btn-lg", "pull-right", 3, "click"], [1, "modal-title"], [3, "value"]], template: function DeviceActivationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "h1");
        i0.ɵɵtext(4, "PRODA device registration");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "p");
        i0.ɵɵtext(6, "Activate your registered PRODA device");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 3);
        i0.ɵɵelementStart(8, "button", 4);
        i0.ɵɵlistener("click", function DeviceActivationComponent_Template_button_click_8_listener() { return ctx.activateNewDevice(); });
        i0.ɵɵtext(9, "Activate new");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 5);
        i0.ɵɵelementStart(11, "dx-data-grid", 6);
        i0.ɵɵlistener("onCellPrepared", function DeviceActivationComponent_Template_dx_data_grid_onCellPrepared_11_listener($event) { return ctx.onCellPrepared($event); });
        i0.ɵɵelement(12, "dxo-paging", 7);
        i0.ɵɵelement(13, "dxi-column", 8);
        i0.ɵɵelement(14, "dxi-column", 9);
        i0.ɵɵelementStart(15, "dxi-column", 10);
        i0.ɵɵtemplate(16, DeviceActivationComponent_div_16_Template, 3, 1, "div", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(17, "dxi-column", 12);
        i0.ɵɵelement(18, "dxi-column", 13);
        i0.ɵɵelement(19, "dxi-column", 14);
        i0.ɵɵelement(20, "dxi-column", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div");
        i0.ɵɵelementStart(22, "dx-popup", 16);
        i0.ɵɵlistener("visibleChange", function DeviceActivationComponent_Template_dx_popup_visibleChange_22_listener($event) { return ctx.popupVisible = $event; })("onHiding", function DeviceActivationComponent_Template_dx_popup_onHiding_22_listener() { return ctx.cancel(); });
        i0.ɵɵtemplate(23, DeviceActivationComponent_div_23_Template, 3, 0, "div", 11);
        i0.ɵɵelementStart(24, "div", 17);
        i0.ɵɵelementStart(25, "form");
        i0.ɵɵelementStart(26, "div", 18);
        i0.ɵɵelementStart(27, "label", 19);
        i0.ɵɵtext(28, "PRODA organisation RA number");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "select", 20);
        i0.ɵɵlistener("ngModelChange", function DeviceActivationComponent_Template_select_ngModelChange_29_listener($event) { return ctx.prodaOrganisationId = $event; });
        i0.ɵɵtemplate(30, DeviceActivationComponent_option_30_Template, 2, 2, "option", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "div", 22);
        i0.ɵɵtext(32);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "div", 18);
        i0.ɵɵelementStart(34, "label", 23);
        i0.ɵɵtext(35, "Device name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(36, "input", 24, 25);
        i0.ɵɵlistener("ngModelChange", function DeviceActivationComponent_Template_input_ngModelChange_36_listener($event) { return ctx.deviceName = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "div", 26);
        i0.ɵɵtext(39);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(40, "div", 18);
        i0.ɵɵelementStart(41, "label", 27);
        i0.ɵɵtext(42, "Device activation code");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(43, "input", 28, 25);
        i0.ɵɵlistener("ngModelChange", function DeviceActivationComponent_Template_input_ngModelChange_43_listener($event) { return ctx.deviceActivationCode = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(45, "div", 29);
        i0.ɵɵtext(46);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(47, "div", 30);
        i0.ɵɵelementStart(48, "strong");
        i0.ɵɵtext(49);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(50, "br");
        i0.ɵɵtemplate(51, DeviceActivationComponent_ul_51_Template, 3, 1, "ul", 31);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(52, "div", 32);
        i0.ɵɵelementStart(53, "button", 33);
        i0.ɵɵlistener("click", function DeviceActivationComponent_Template_button_click_53_listener() { return ctx.cancel(); });
        i0.ɵɵtext(54, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(55, "button", 34);
        i0.ɵɵlistener("click", function DeviceActivationComponent_Template_button_click_55_listener() { return ctx.saveNewDevice(); });
        i0.ɵɵtext(56, "Save");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(11);
        i0.ɵɵproperty("dataSource", ctx.activatedDevices)("columns", i0.ɵɵpureFunction0(41, _c0))("showBorders", true)("showColumnLines", true)("showRowLines", true)("cellHintEnabled", true)("allowColumnResizing", true)("columnAutoWidth", true)("noDataText", "No devices");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("enabled", false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("width", 190)("allowSorting", false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("width", 163)("allowSorting", false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("width", 190)("allowSorting", false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("dxTemplateOf", "facilitiesTemplate");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("width", 110)("allowSorting", false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("width", 143)("allowSorting", false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("width", 122)("allowSorting", false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("width", 190)("allowSorting", false);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("visible", ctx.popupVisible);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("dxTemplateOf", "title");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("disabled", ctx.devicesDropdownList.length < 2)("ngModel", ctx.prodaOrganisationId);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.devicesDropdownList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("hidden", ctx.prodaOrganisationIdValidationMessage == "");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.prodaOrganisationIdValidationMessage, " ");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngModel", ctx.deviceName);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("hidden", ctx.deviceNameValidationMessage == "");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.deviceNameValidationMessage, " ");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngModel", ctx.deviceActivationCode);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("hidden", ctx.deviceActivationCodeValidationMessage == "");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.deviceActivationCodeValidationMessage, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("hidden", ctx.serverValidationMessages.length == 0 && ctx.serverErrorMessage == "");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.serverErrorMessage);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.serverValidationMessages);
    } }, directives: [i4.DxDataGridComponent, i5.DxoPagingComponent, i5.DxiColumnComponent, i6.DxTemplateDirective, i4.DxPopupComponent, i7.ɵangular_packages_forms_forms_y, i7.NgControlStatusGroup, i7.NgForm, i7.SelectControlValueAccessor, i7.NgControlStatus, i7.NgModel, i8.NgForOf, i7.DefaultValueAccessor, i7.RequiredValidator, i7.MaxLengthValidator, i7.NgSelectOption, i7.ɵangular_packages_forms_forms_x], encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DeviceActivationComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'device-activation',
                templateUrl: './deviceActivation.component.html'
            }]
    }], function () { return [{ type: i1.StateService }, { type: i2.OrganisationService }, { type: i3.DnaRSnackBarService }, { type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['notification.service']
            }] }]; }, { dataGrid: [{
            type: core_1.ViewChild,
            args: [devextreme_angular_1.DxDataGridComponent, { static: false }]
        }], popup: [{
            type: core_1.ViewChild,
            args: [devextreme_angular_1.DxPopupComponent, { static: false }]
        }] }); })();
